import {
  AmountV1CurrencyEnum,
  type GetCarriersV1,
} from '@redteclab/api/clients/bully'

const sortCarriers = (
  carrierA: GetCarriersV1,
  carrierB: GetCarriersV1,
): number => {
  if (typeof carrierA.freeShippingThreshold !== 'number') {
    return 1
  }
  if (typeof carrierB.freeShippingThreshold !== 'number') {
    return -1
  }

  return carrierA.freeShippingThreshold - carrierB.freeShippingThreshold
}

export const shippingAccessorGetMinFreeShippingThreshold = (
  carriers: GetCarriersV1[] | undefined,
): {
  amount: number | null
  currency: AmountV1CurrencyEnum
} => {
  if (!carriers || carriers.length === 0) {
    return {
      amount: null,
      currency: AmountV1CurrencyEnum.Eur,
    }
  }

  const sortedShippingCarriers = carriers.toSorted(sortCarriers)

  return {
    amount: sortedShippingCarriers[0].freeShippingThreshold,
    currency: sortedShippingCarriers[0].currency as AmountV1CurrencyEnum,
  }
}
